import { defineComponent as b, computed as c, useCssVars as C, createBlock as w, openBlock as n, resolveDynamicComponent as S, normalizeProps as _, guardReactiveProps as V, withCtx as R, renderSlot as I, createElementBlock as d, createCommentVNode as v, Fragment as h, createElementVNode as r, renderList as T, toDisplayString as k, resolveComponent as j, createVNode as z, mergeProps as A } from "vue";
import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const m = b({
  inheritAttrs: !1,
  props: {
    as: { type: String, default: () => "span" },
    validation: Object,
    /** include error with no changes */
    validationSilentError: Boolean,
    /**
     * only include error from matched rules.
     * regexp execute on rule.$uid = <property path>-<rule key>
     * ex: "a.b.0.c-required"
     */
    validationIncludeRule: Array,
    /** skip errors */
    hideErrors: Boolean,
    /** hide exclamation icon, only display tooltip and red ring */
    hideIcon: Boolean,
    position: {
      type: Object,
      default: () => ({ bottom: "120%", right: "0px" })
    }
  },
  setup(e, { attrs: t }) {
    var u, p, i, a;
    const o = c(() => {
      var f;
      if (!e.validation) return [];
      const l = e.validationSilentError ? e.validation.$silentErrors : e.validation.$errors;
      return (f = e.validationIncludeRule) != null && f.length ? l.filter((B) => e.validationIncludeRule.some((E) => E.test(B.$uid))) : l;
    }), s = c(() => !e.hideErrors && !!o.value.length);
    return {
      errors: o,
      haveError: s,
      attrs: c(() => ({
        ...t,
        class: s.value ? ["tx-error2", t.class] : t.class
      })),
      positionBottom: (u = e.position) == null ? void 0 : u.bottom,
      positionTop: (p = e.position) == null ? void 0 : p.top,
      positionRight: (i = e.position) == null ? void 0 : i.right,
      positionLeft: (a = e.position) == null ? void 0 : a.left
    };
  }
}), $ = () => {
  C((e) => ({
    "6719b442": e.positionBottom,
    "5d1292c4": e.positionTop,
    "4e848925": e.positionRight,
    "5d5c53de": e.positionLeft
  }));
}, g = m.setup;
m.setup = g ? (e, t) => ($(), g(e, t)) : $;
const L = {
  key: 0,
  class: "tx-error-icon"
}, N = ["id"], O = ["id"];
function P(e, t, o, s, u, p) {
  return n(), w(S(e.$props.as), _(V(e.attrs)), {
    default: R(() => {
      var i, a;
      return [
        I(e.$slots, "default"),
        e.haveError ? (n(), d(h, { key: 0 }, [
          e.$props.hideIcon ? v("", !0) : (n(), d("div", L, t[0] || (t[0] = [
            r("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512",
              fill: "currentColor",
              class: "tt-h-4 tt-w-4"
            }, [
              r("rect", {
                style: { fill: "#ffffff" },
                width: "135",
                height: "300",
                x: "190",
                y: "115"
              }),
              r("path", { d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" })
            ], -1)
          ]))),
          r("div", {
            class: "tx-error-tooltip",
            id: (i = e.validation) != null && i.$path ? `v-${(a = e.validation) == null ? void 0 : a.$path}` : void 0
          }, [
            r("div", null, [
              (n(!0), d(h, null, T(e.errors, (l) => (n(), d("p", {
                key: l.$uid,
                id: l.$uid
              }, k(l.$message), 9, O))), 128))
            ]),
            t[1] || (t[1] = r("svg", {
              x: "0px",
              y: "0px",
              viewBox: "0 0 255 255",
              "xml:space": "preserve"
            }, [
              r("polygon", { points: "0,0 127.5,127.5 255,0" })
            ], -1))
          ], 8, N)
        ], 64)) : v("", !0)
      ];
    }),
    _: 3
  }, 16);
}
const D = /* @__PURE__ */ y(m, [["render", P]]), F = b({
  inheritAttrs: !1,
  name: "t-checkbox",
  props: {
    modelValue: Boolean,
    validation: Object,
    label: String,
    indeterminate: Boolean
  },
  components: { ErrorTooltip2: D },
  emits: ["update:model-value"],
  setup(e, { emit: t }) {
    const o = c({
      get() {
        return e.modelValue;
      },
      set(s) {
        t("update:model-value", s);
      }
    });
    return {
      m: o,
      check() {
        o.value === !0 ? o.value = !1 : o.value === !1 ? o.value = e.indeterminate ? void 0 : !0 : o.value = !0;
      }
    };
  }
}), M = { class: "tx-checkbox" }, q = ["for"];
function G(e, t, o, s, u, p) {
  const i = j("ErrorTooltip2");
  return n(), d("span", M, [
    z(i, A({
      validation: e.validation,
      "hide-icon": "",
      as: "input",
      id: `${e.$attrs.id ? e.$attrs.id : e.$.uid}`,
      type: "checkbox",
      indeterminate: e.m === void 0,
      value: e.m,
      checked: e.m,
      onChange: t[0] || (t[0] = (a) => e.check())
    }, e.$attrs, { position: { bottom: "150%", left: "0" } }), null, 16, ["validation", "id", "indeterminate", "value", "checked"]),
    e.$props.label ? (n(), d("label", {
      key: 0,
      for: `${e.$attrs.id ? e.$attrs.id : e.$.uid}`
    }, k(e.$props.label), 9, q)) : v("", !0)
  ]);
}
const K = /* @__PURE__ */ y(F, [["render", G]]);
export {
  K as default
};
//# sourceMappingURL=Checkbox-B8p-bKhv.js.map
